/* =====================================================
   UPSELL MODAL
   Works with:
     1. Standard Dawn  → <form data-type="add-to-cart-form">
     2. Balmy Drum     → <button class="bpd__atc-btn" data-variant-id="...">
   ===================================================== */
(function () {
  'use strict';

  const modal = document.getElementById('upsell-modal');
  if (!modal) return;

  /* ── Parse data ── */

  let upsellData = {};
  try {
    const el = document.getElementById('upsell-data');
    if (el) upsellData = JSON.parse(el.textContent.trim());
  } catch (e) {
    console.warn('[upsell-modal] JSON parse error', e);
    return;
  }

  function getVariantData(variantId) {
    return (upsellData.variants || {})[variantId] || null;
  }

  function getUpgradeVariantId(variantId) {
    return getVariantData(variantId)?.upgradeId || null;
  }

  /* ── Cart helpers ── */

  const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');

  function getQty() {
    const el = document.querySelector(
      '[data-type="add-to-cart-form"] [name="quantity"], .bpd__qty-input'
    );
    return el ? (parseInt(el.value, 10) || 1) : 1;
  }

  async function addToCartAndOpenDrawer(variantId, qty) {
    const cartDrawer = document.querySelector('cart-drawer');
    const sections   = cartDrawer ? cartDrawer.getSectionsToRender().map((s) => s.id) : [];

    try {
      const res = await fetch(root + '/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id:           parseInt(variantId, 10),
          quantity:     qty,
          sections:     sections,
          sections_url: window.location.pathname,
        }),
      });

      if (res.ok) {
        const data = await res.json();
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        } else {
          window.location.href = root + '/cart';
        }
      } else {
        const err = await res.json().catch(() => ({}));
        console.error('[upsell-modal] Cart add failed:', err.description || err);
      }
    } catch (err) {
      console.error('[upsell-modal] Network error:', err);
    }
  }

  /* ── Countdown timer ── */

  const COUNTDOWN_DURATION = 3 * 60 * 1000;
  const STORAGE_KEY = 'um_deadline_' + (window.location.pathname || '');
  let countdownInterval = null;

  function initDeadline() {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      const deadline = parseInt(stored, 10);
      if (deadline > Date.now()) return deadline;
    }
    const deadline = Date.now() + COUNTDOWN_DURATION;
    sessionStorage.setItem(STORAGE_KEY, String(deadline));
    return deadline;
  }

  function formatTime(ms) {
    if (ms <= 0) return '00:00';
    const totalSec = Math.ceil(ms / 1000);
    const m = Math.floor(totalSec / 60);
    const s = totalSec % 60;
    return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
  }

  function startCountdown() {
    stopCountdown();
    const deadline = initDeadline();
    const timerEl  = document.getElementById('um-timer');
    if (!timerEl) return;

    function tick() {
      const remaining = deadline - Date.now();
      timerEl.textContent = formatTime(remaining);
      if (remaining <= 0) stopCountdown();
    }

    tick();
    countdownInterval = setInterval(tick, 1000);
  }

  function stopCountdown() {
    if (countdownInterval !== null) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
  }

  /* ── Render slot cards + title + bullets ── */

  function escHtml(str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function applyTokens(text, vd) {
    const slots = (vd.slots || []).filter(Boolean);
    const b = (val) => val ? '<strong>' + escHtml(String(val)) + '</strong>' : '';
    return escHtml(text)
      .replace(/\{slot1_price\}/g, b(slots[0]?.compareAtPriceFormatted))
      .replace(/\{slot2_price\}/g, b(slots[1]?.compareAtPriceFormatted))
      .replace(/\{slot3_price\}/g, b(slots[2]?.compareAtPriceFormatted))
      .replace(/\{total_price\}/g,   b(vd.totalOriginalFormatted))
      .replace(/\{upgrade_price\}/g, b(vd.upgradePriceFormatted))
      .replace(/\{savings\}/g,       b(vd.savingsFormatted));
  }

  function renderModal(vd) {
    /* Title */
    const titleEl = document.getElementById('um-title');
    if (titleEl) titleEl.textContent = vd.modalTitle || '';

    /* Slot cards */
    const container = document.getElementById('um-hero-products');
    if (container) {
      const slots = (vd.slots || []).filter(Boolean);
      container.innerHTML = slots
        .map(function (slot, i) {
          return (
            (i > 0 ? '<span class="um-plus" aria-hidden="true">+</span>' : '') +
            '<div class="um-hero-card">' +
              '<div class="um-hero-img-wrap">' +
                (slot.img
                  ? '<img src="' + escHtml(slot.img) + '" alt="' + escHtml(slot.title) + '" width="100" height="100" loading="lazy">'
                  : '') +
              '</div>' +
              '<div class="um-hero-card-body">' +
                '<div class="um-hero-card-name">' + escHtml(slot.title) + '</div>' +
                '<s class="um-hero-card-price">' + escHtml(slot.compareAtPriceFormatted || slot.priceFormatted) + '</s>' +
              '</div>' +
            '</div>'
          );
        })
        .join('');
    }

    /* Bullets — clear previous, then add new */
    const descEl = document.getElementById('um-description');
    if (descEl) {
      const old = descEl.querySelector('ul.um-bullets');
      if (old) old.remove();
      const oldTitle = descEl.querySelector('.um-bullets-title');
      if (oldTitle) oldTitle.remove();

      if (vd.bullets && vd.bullets.length > 0) {
        const ul = document.createElement('ul');
        ul.className = 'um-bullets';
        vd.bullets.forEach(function (b) {
          const li = document.createElement('li');
          li.innerHTML = applyTokens(b, vd);
          ul.appendChild(li);
        });
        const urgency = descEl.querySelector('.um-urgency');
        if (vd.bulletsTitle) {
          const heading = document.createElement('p');
          heading.className = 'um-bullets-title';
          heading.textContent = vd.bulletsTitle;
          descEl.insertBefore(heading, urgency || null);
        }
        descEl.insertBefore(ul, urgency || null);
      }
    }
  }

  /* ── Open / close ── */

  function openModal(variantId) {
    const vd = getVariantData(variantId);
    if (!vd || !vd.upgradeId) return;

    modal.dataset.upgradeVariantId = vd.upgradeId;
    modal.dataset.sourceVariantId  = variantId;

    renderModal(vd);

    setText('um-total-original', vd.totalOriginalFormatted);
    setText('um-upgrade-price',  vd.upgradePriceFormatted);
    setText('um-discount-pct',   vd.discountPct ?? '-');

    const callout = document.getElementById('um-savings-callout');
    if (callout && vd.savingsFormatted) {
      setText('um-savings-inline', vd.savingsFormatted);
      callout.hidden = false;
    }

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    document.getElementById('um-close')?.focus();
    startCountdown();
  }

  function closeModal() {
    stopCountdown();
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function setText(id, value) {
    const el = document.getElementById(id);
    if (el && value != null) el.textContent = value;
  }

  /* ── Skip: close modal + add original product + open drawer ── */

  function doSkip() {
    const sourceVariantId = modal.dataset.sourceVariantId;
    closeModal();

    if (form) {
      bypassForm = true;
      form.requestSubmit ? form.requestSubmit() : form.querySelector('[name="add"]')?.click();
      bypassForm = false;
    } else if (sourceVariantId) {
      addToCartAndOpenDrawer(sourceVariantId, getQty());
    }
  }

  /* ── Close controls ── */

  document.getElementById('um-close')?.addEventListener('click', doSkip);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) doSkip();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) doSkip();
  });

  /* ─────────────────────────────────────────────────────
     MODE 1 — Standard Dawn: <form data-type="add-to-cart-form">
  ───────────────────────────────────────────────────── */

  const form = document.querySelector('[data-type="add-to-cart-form"]');
  let bypassForm = false;

  if (form) {
    form.addEventListener(
      'submit',
      function (e) {
        if (bypassForm) return;
        const variantId = form.querySelector('.product-variant-id')?.value;
        if (!variantId || !getUpgradeVariantId(variantId)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        openModal(variantId);
      },
      true
    );

    document.getElementById('um-skip')?.addEventListener('click', doSkip);
  }

  /* ─────────────────────────────────────────────────────
     MODE 2 — Balmy Drum: <button class="bpd__atc-btn">
  ───────────────────────────────────────────────────── */

  const bpdBtn = document.querySelector('.bpd__atc-btn');

  if (bpdBtn) {
    bpdBtn.addEventListener(
      'click',
      function (e) {
        const variantId = bpdBtn.dataset.variantId;
        if (!variantId || !getUpgradeVariantId(variantId)) return;
        e.stopImmediatePropagation();
        openModal(variantId);
      },
      true
    );

    document.getElementById('um-skip')?.addEventListener('click', doSkip);
  }

  /* ─────────────────────────────────────────────────────
     UPGRADE — add upgrade variant, open cart drawer
  ───────────────────────────────────────────────────── */

  document.getElementById('um-upgrade')?.addEventListener('click', async function () {
    const upgradeVariantId = modal.dataset.upgradeVariantId;
    if (!upgradeVariantId) return;

    const btn     = this;
    const spinner = btn.querySelector('.um-btn-spinner');
    const label   = btn.querySelector('.um-btn-label');

    btn.disabled = true;
    if (spinner) spinner.hidden = false;
    if (label)   label.textContent = 'Adding to cart…';

    closeModal();
    await addToCartAndOpenDrawer(upgradeVariantId, getQty());

    resetBtn(btn, spinner, label);
  });

  function resetBtn(btn, spinner, label) {
    btn.disabled = false;
    if (spinner) spinner.hidden = true;
    if (label)   label.textContent = 'Yes, Upgrade My Balmy.';
  }

})();
